import { Injectable } from "@angular/core";
import { ICorso } from "app/shared/models/corso.interface";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceCorsi extends BASEMysqlService {

  prefix = 'corsi_'

  //////////////////////////////////////////////////////////////////////////////////////////

  list(filter?): Promise<any> {
    let data = {
      auth: this.getAuth(),
      filter: filter
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
  }

  get(id): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
  }

  upsert(item: ICorso): Promise<any> {
    let data = {
      auth: this.getAuth(),
      item: item
    }

    return this.http.post<ICorso[]>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
  }

  delete(id: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
  }

}